import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { usePlayer, stationKey } from "@/context/PlayerContext";
import { api } from "@/lib/api";

const mins = (hhmm) => { const [h, m] = hhmm.split(":").map(Number); return h * 60 + m; };

// Returns the occurrence id (schedule + start date) if the slot is on air now.
export const activeOccurrence = (s, now = new Date()) => {
  const dow = (now.getDay() + 6) % 7;
  const cur = now.getHours() * 60 + now.getMinutes();
  const st = mins(s.start), en = mins(s.end);
  const day = (offset) => { const d = new Date(now); d.setDate(d.getDate() - offset); return d.toLocaleDateString("sv"); };
  if (st < en) return s.days.includes(dow) && cur >= st && cur < en ? `${s.id}:${day(0)}` : null;
  if (s.days.includes(dow) && cur >= st) return `${s.id}:${day(0)}`;
  if (s.days.includes((dow + 6) % 7) && cur < en) return `${s.id}:${day(1)}`;
  return null;
};

export const RadioScheduler = () => {
  const p = usePlayer();
  const pRef = useRef(p);
  pRef.current = p;
  const schedules = useRef([]);
  const active = useRef(null);

  useEffect(() => {
    const load = () => api.get("/radio/schedules").then((r) => { schedules.current = r.data; }).catch(() => {});
    load();
    window.addEventListener("radio-schedules-changed", load);
    const reload = setInterval(load, 300000);
    const tick = () => {
      const player = pRef.current;
      if (active.current) {
        const s = schedules.current.find((x) => x.id === active.current.id);
        if (!s || !s.enabled || activeOccurrence(s) !== active.current.occ) {
          if (player.liveKey === active.current.key) {
            player.clear();
            toast(`Scheduled radio ended: ${active.current.name}`);
          }
          active.current = null;
        }
      }
      for (const s of schedules.current) {
        if (!s.enabled || !s.station) continue;
        const occ = activeOccurrence(s);
        if (!occ || localStorage.getItem(`sched:${occ}`)) continue;
        localStorage.setItem(`sched:${occ}`, "1");
        const key = stationKey(s.station);
        active.current = { id: s.id, occ, key, name: s.station.name };
        if (player.liveKey !== key) player.playStation(s.station);
        toast.success(`Scheduled radio: ${s.station.name}`, { description: `Playing until ${s.end}` });
        break;
      }
    };
    const iv = setInterval(tick, 20000);
    const first = setTimeout(tick, 3000);
    return () => { window.removeEventListener("radio-schedules-changed", load); clearInterval(reload); clearInterval(iv); clearTimeout(first); };
  }, []);
  return null;
};
